import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div className="flex min-h-screen items-center justify-center bg-black px-6">
            <div className="text-center">
              <p className="text-[16px] font-medium text-red-400">Something went wrong</p>
              <p className="mt-2 text-[13px] leading-relaxed text-[rgba(255,255,255,0.4)]">
                {this.state.error.message}
              </p>
              <pre className="mt-4 max-h-40 overflow-auto rounded bg-[rgba(255,255,255,0.05)] p-3 text-left text-[10px] text-[rgba(255,255,255,0.3)]">
                {this.state.error.stack}
              </pre>
              <button
                onClick={() => this.setState({ error: null })}
                className="mt-4 rounded-full bg-white/10 px-5 py-2 text-[13px] text-white active:scale-95"
              >
                Try again
              </button>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
